import { DISCONTINUED_FAULT_SEVERITY_IDS, FaultSeveritySelect } from 'components/selects/FaultSeveritySelect';
import { IFormInputSpecFaultSeverity } from 'pages/revisions-module/template-editor/editors/form/types';

/**
 * Preview for a text input.
 */
export default function FaultSeverityInputPreview({ spec }: { spec: IFormInputSpecFaultSeverity }) {
  return (
    <FaultSeveritySelect
      required={spec.required}
      readOnly={spec.readOnly}
      size="sm"
      excludedFaultSeverityIds={[...DISCONTINUED_FAULT_SEVERITY_IDS]}
    />
  );
}
